import { sha256 } from "js-sha256";
import { sha512 } from "js-sha512";

// crypto.randomUUID 仅在安全上下文（HTTPS / localhost）存在，内网 HTTP + IP/hostname 访问时缺失。
// 各前端入口应最先 import 本模块（副作用安装），之后业务代码与三方依赖（含 vendor）可直接使用 crypto.randomUUID()。
// 回退实现必须内联在此，不能委托给「运行时探测 crypto.randomUUID 再调用」的帮助函数——那会递归调用到本 polyfill 自身。
if (typeof crypto !== "undefined" && !crypto.randomUUID) {
  Object.defineProperty(crypto, "randomUUID", {
    value: () =>
      "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) => {
        const n = Number(c);
        return (
          n ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (n / 4)))
        ).toString(16);
      }),
    writable: true,
    configurable: true,
  });
}

// crypto.subtle 与 randomUUID 同理，非安全上下文下为 undefined。仅 polyfill 仓库内实际用到的
// digest（SHA-256 / SHA-512，js-sha256 / js-sha512 纯 JS 实现）；其余 SubtleCrypto 方法不提供，
// 调用会在 TypeError 处及早暴露。Worker 是独立 realm，主入口的 import 覆盖不到，各 worker 入口须自行 import 本模块。
if (typeof crypto !== "undefined" && !crypto.subtle) {
  Object.defineProperty(crypto, "subtle", {
    value: {
      digest: (
        algorithm: AlgorithmIdentifier,
        data: BufferSource,
      ): Promise<ArrayBuffer> => {
        const name = (
          typeof algorithm === "string" ? algorithm : algorithm.name
        )
          .toUpperCase()
          .replace("-", "");
        const bytes =
          data instanceof ArrayBuffer
            ? new Uint8Array(data)
            : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        if (name === "SHA256") {
          return Promise.resolve(sha256.arrayBuffer(bytes));
        }
        if (name === "SHA512") {
          return Promise.resolve(sha512.arrayBuffer(bytes));
        }
        return Promise.reject(
          new DOMException(
            `crypto.subtle polyfill 不支持算法：${name}（仅 SHA-256 / SHA-512）`,
            "NotSupportedError",
          ),
        );
      },
    },
    writable: true,
    configurable: true,
  });
}
